import {
  IAdvancedRichText,
  IBaseLayoutOptions,
  IInputWidget,
  WidgetType,
} from '@framework/engine';

export interface IEmailVerificationWidgetLayout extends IBaseLayoutOptions {
  /** Nascondi etichetta */
  // hideLabel?: boolean;
  startButtonText?: string;
  startHelpText?: IAdvancedRichText;
  endButtonText?: string;
  endHelpText?: IAdvancedRichText;
}

export const WidgetEmailVerificationType =
  'email-verification' as WidgetType.EmailVerification;

/**
 * Input in Verifica Email
 */
export interface IEmailVerificationWidget extends IInputWidget {
  type: WidgetType.EmailVerification;

  layout?: IEmailVerificationWidgetLayout;
}
